import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import usePageProps from '@/routes/usePageProps';
import ShoppingCartPage from '@/pages/ShoppingCartPage';

const ShoppingCart: React.FC<RouteComponentProps> = props => {
  const pageProps = usePageProps({ props });

  if (pageProps.reducersState.app.loadingPlatformConfig) {
    return null;
  }

  return <ShoppingCartPage {...pageProps} />
};

export default ShoppingCart;
